import { area, feature, featureCollection } from '@turf/turf'

export class ExclusionZone {
	constructor(
		readonly name: string,
		readonly description: string,
		readonly monitoredAreaId: string,
		readonly monitoredAreaName: string,
		readonly zones: object[],
		readonly code?: number,
		readonly id?: string,
	) {}

	get zoneCount(): number {
		return this.zones.length
	}

	get area(): number {
		if (!this.zoneCount) return 0

		const features = this.zones.map((zone) => feature(zone))
		return Number((area(featureCollection(features)) / 10000).toFixed(2))
	}

	get zonesAreaLabel(): string {
		return `${this.area} ha`
	}
}
